import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IRace } from "../interfaces/race";

@Injectable({
  providedIn: 'root'
})
export class RaceService {
    private rootUrl: string = "/api/races";

    constructor(private httpClient: HttpClient) { }

    public getRaces(): Observable<IRace[]> {
        const url = this.rootUrl;
        return this.httpClient.get<IRace[]>(url);
    }
}
